import { createSlice } from '@reduxjs/toolkit';
import i18n from '../../i18n/i18n';
import { AcademicYearState } from '../../interface/academicYear.interface';
import {
  createAcademicYear,
  getAcademicYears,
  updateAcademicYear,
} from '../action/academicYear.action';

const initialState: AcademicYearState = {
  academicYears: [],
  isLoading: false,
  total: 0,
  error: undefined,
  currentPage: 1,
  perPageRow: 10,
};

const academicYearSlice = createSlice({
  name: 'academicYear',
  initialState,
  reducers: {
    resetAcademicYear(state) {
      state.academicYears = [];
      state.total = 0;
      state.error = undefined;
      state.currentPage = 1;
      state.perPageRow = 10;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAcademicYear.pending, (state) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(createAcademicYear.fulfilled, (state) => {
        state.isLoading = false;
        state.error = undefined;
      })
      .addCase(createAcademicYear.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_create_academic_year', 'Failed to create academic year.');
      })
      .addCase(updateAcademicYear.pending, (state) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(updateAcademicYear.fulfilled, (state) => {
        state.isLoading = false;
        state.error = undefined;
      })
      .addCase(updateAcademicYear.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_update_academic_year', 'Failed to update academic year.');
      })
      .addCase(getAcademicYears.pending, (state) => {
        state.isLoading = true;
        state.error = undefined;
      })
      .addCase(getAcademicYears.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = undefined;
        state.academicYears = action.payload.data.academicYear;
        state.total = action.payload.data.total;
        state.currentPage = Number(action.payload.data.currentPage);
        state.perPageRow = Number(action.payload.data.perPageRow);
      })
      .addCase(getAcademicYears.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload?.message ||
          i18n.t('toast.failed_to_fetch_academic_years', 'Failed to fetch academic years.');
      });
  },
});

export const { resetAcademicYear } = academicYearSlice.actions;
export default academicYearSlice.reducer;
